import type { HTMLAttributes } from 'react';
import { cn } from '../../../lib/cn.js';

/**
 * Skeleton shimmer placeholder. Spec source:
 * `_bmad-output/planning-artifacts/ux-design-directions.html` `.sk` rule —
 * linear gradient over surface fill, animated via `skeleton-shimmer` keyframe
 * registered in `app.css`. Reduced-motion users see a flat band (the
 * animation is gated behind `motion-safe:`).
 *
 * Default shape is a rounded rectangle; size is driven by the `className`
 * the caller passes (`h-`, `w-`, `aspect-`, ...).
 */
export type SkeletonProps = HTMLAttributes<HTMLDivElement>;

export function Skeleton({ className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'rounded-md bg-[length:200%_100%]',
        'bg-[linear-gradient(90deg,#141414_25%,#1a1a1a_50%,#141414_75%)]',
        'motion-safe:animate-skeleton-shimmer',
        className,
      )}
      {...rest}
    />
  );
}
